/* ============================================================
   Tiroir panier — presentation compacte
   ============================================================
   Charge APRES mirthly.js et mirthly-gift.js.

   Separation des roles, volontaire :
     mirthly-gift.js          les REGLES de panier (cadeau, echange de lot)
     mirthly-cart-drawer.js   la PRESENTATION du tiroir

   Ce fichier n ajoute, ne retire et ne modifie aucune ligne de panier. Il
   n invente aucun montant non plus : les prix payes viennent de /cart.js,
   les prix barres de /products/<handle>.js, que /cart.js n expose pas.

   ON DEPLACE, ON NE RECONSTRUIT PAS
   mirthly.js pose ses propres gestionnaires sur les boutons de quantite, les
   cases des options et le bouton de commande. Recreer ces elements les
   perdrait. On reutilise donc les noeuds existants et on ne fait que les
   reordonner et les rehabiller. Retirer ce fichier du layout rend le tiroir
   d origine, entierement fonctionnel.
   ============================================================ */
(function () {
  "use strict";

  var CAL_RE = /(\d+)\s*calendars?/i;
  var produits = {};          /* handle -> fiche produit, mise en cache */

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function reglage(nom, defaut) {
    var d = $("#drawer");
    var v = d && d.getAttribute(nom);
    return v === null || v === undefined || v === "" ? defaut : v;
  }

  function idCadeau() {
    return (window.MirthlyGift && window.MirthlyGift.variantId) || null;
  }

  function estCadeau(ligne) {
    var g = idCadeau();
    if (g && String(ligne.variant_id) === String(g)) return true;
    var p = ligne.properties || {};
    return p._mirthly_free_gift === "true" || p._mirthly_free_gift === true;
  }

  /* Les options additionnelles sont des produits comme les autres dans le
     panier. Elles ne sont ni un calendrier ni un cadeau : elles ont leur
     propre rangee et ne comptent pas dans le decompte des calendriers. */
  function idsOptions() {
    var a = (window.MIRTHLY_DATA && window.MIRTHLY_DATA.addons) || {};
    return Object.keys(a).map(function (k) { return a[k] && String(a[k].id); })
      .filter(Boolean);
  }

  function estOption(ligne) {
    return idsOptions().indexOf(String(ligne.variant_id)) !== -1;
  }

  /* Combien de calendriers dans UNE unite de cette variante. Un lot
     « 2 calendars » vaut deux calendriers par unite. Sans mention chiffree
     on suppose un, ce qui reste vrai pour un produit simple. */
  function parUnite(ligne) {
    var m = CAL_RE.exec(ligne.variant_title || "");
    return m ? Number(m[1]) : 1;
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var f = (window.MIRTHLY_DATA && window.MIRTHLY_DATA.moneyFormat) || null;
    if (!f) return "$" + v;
    return f
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace(".", ","));
  }

  /* Economie affichee en dollars ronds, arrondie vers le BAS : on
     annonce  $20  pour 20,06 $ economises, jamais plus que le reel. */
  function moneyRond(cents) {
    var f = (window.MIRTHLY_DATA && window.MIRTHLY_DATA.moneyFormat) || "${{amount}}";
    return f.replace(/\{\{\s*amount\w*\s*\}\}/, String(Math.floor(cents / 100)));
  }

  function jsonGet(url) {
    return fetch(url, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  /* /cart.js ne renvoie pas compare_at_price. On lit la fiche produit, une
     seule fois par handle, pour obtenir le prix barre reel plutot que de le
     recalculer de tete. */
  function fiche(handle) {
    if (!handle) return Promise.resolve(null);
    if (produits[handle]) return Promise.resolve(produits[handle]);
    return jsonGet("/products/" + handle + ".js")
      .then(function (p) { produits[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function compareAt(ligne) {
    var p = produits[ligne.handle];
    if (p) {
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === String(ligne.variant_id)) {
          return p.variants[i].compare_at_price || null;
        }
      }
      return null;
    }
    /* Repli sans reseau : la page produit expose deja ses variantes
       (MIRTHLY_DATA), avec le meme prix barre que Shopify. C est ce qui
       permet de repeindre le tiroir sans attendre /products/<handle>.js. */
    var v = (window.MIRTHLY_DATA && window.MIRTHLY_DATA.variants) || [];
    for (var k = 0; k < v.length; k++) {
      if (String(v[k].id) === String(ligne.variant_id)) return v[k].compare || null;
    }
    return null;
  }

  /* ----------------------------------------------------------------
     Comptes
     ----------------------------------------------------------------
     Le detail affiche doit se verifier a la calculatrice :
       sous-total avant remises − remises = total Shopify.
     Si un ecart subsiste — une remise que nous ne savons pas nommer — il
     apparait sur une ligne  Discount  plutot que d etre absorbe en silence.
     Un recapitulatif qui ne tombe pas juste est pire que pas de
     recapitulatif : le client le verifie, lui.
     ---------------------------------------------------------------- */
  /* Nombre d articles a afficher dans le compteur : les lots achetes.
     Un lot de 2 calendriers compte 1. Le cadeau offert et les options
     (protection, emballage) ne comptent pas : le client n a choisi qu un
     produit, le compteur doit dire 1. */
  function articles(items) {
    return (items || []).reduce(function (s, l) {
      return s + (estCadeau(l) || estOption(l) ? 0 : l.quantity);
    }, 0);
  }

  /* Offre BUY 1 GET 1 FREE (mirthly-bogo.js). Absente ou terminee, le
     tiroir se comporte exactement comme avant. */
  function bogo() {
    var b = window.MirthlyBogo;
    return b && typeof b.gratuits === "function" ? b : null;
  }

  function bogoActif() {
    var b = bogo();
    return !!(b && b.actif());
  }

  function gratuitsDe(ligne) {
    var b = bogo();
    return b && !estCadeau(ligne) ? b.gratuits(ligne) : { unites: 0, montant: 0 };
  }

  function comptes(cart) {
    var c = { avant: 0, lot: 0, cadeau: 0, calendriers: 0, total: cart.total_price,
              articles: articles(cart.items), bogo: 0 };
    (cart.items || []).forEach(function (l) {
      c.bogo += gratuitsDe(l).montant;
      if (estCadeau(l)) {
        c.avant += l.original_line_price;
        c.cadeau += Math.max(0, l.original_line_price - l.final_line_price);
        return;
      }
      if (estOption(l)) {
        c.avant += l.final_line_price;
        return;
      }
      c.calendriers += parUnite(l) * l.quantity;
      var barre = compareAt(l);
      var reference = barre ? barre * l.quantity : l.original_line_price;
      c.avant += reference;
      c.lot += Math.max(0, reference - l.final_line_price);
    });
    c.reste = c.avant - c.lot - c.cadeau - c.total;
    return c;
  }

  /* ----------------------------------------------------------------
     Peinture
     ---------------------------------------------------------------- */

  function enTete(nb) {
    var head = $(".dw-head");
    if (!head) return;
    if (!$(".mc-logo", head)) {
      var logo = document.createElement("span");
      logo.className = "mc-logo";
      logo.innerHTML = "Mirthly<i>.</i>";
      head.insertBefore(logo, head.firstChild);
    }
    var titre = $("#dwTitle");
    var cnt = $("#dwCount");
    if (titre && cnt) {
      /* On reecrit le noeud de texte, pas le titre entier : #dwCount est
         reutilise par mirthly.js a chaque rendu. */
      titre.childNodes[0].nodeValue = "Cart ";
      cnt.textContent = "(" + nb + ")";
    }
  }

  /* Associe chaque rangee du tiroir a sa ligne de panier par la cle posee
     sur les boutons de quantite. On evite ainsi de se fier a l ordre
     d affichage, qui n est pas garanti. */
  function ligneDe(rangee, cart) {
    var btn = rangee.querySelector("[data-key]");
    if (!btn) return null;
    var cle = btn.getAttribute("data-key");
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === cle) return items[i];
    }
    return null;
  }

  /* Le libelle ne doit jamais contredire le pas-a-pas de quantite juste en
     dessous. Le selecteur dit 1 ; le texte doit donc dire  un lot , et
     preciser ce que ce lot contient — pas  2 calendars  tout court. */
  function libelle(ligne) {
    var n = parUnite(ligne);
    var q = ligne.quantity;
    if (n > 1) {
      return q === 1
        ? "1 bundle — includes " + n + " calendars"
        : q + " bundles — " + (n * q) + " calendars";
    }
    var titre = ligne.variant_title;
    if (titre && titre !== "Default Title" && !CAL_RE.test(titre)) {
      /* Variante qui ne parle pas en calendriers : on la reprend telle
         quelle plutot que d inventer une formulation. */
      return q > 1 ? titre + " × " + q : titre;
    }
    return q + (q === 1 ? " calendar" : " calendars");
  }

  /* Un calendrier : une variante de la fiche (MIRTHLY_DATA) ou une
     variante qui parle en calendriers. */
  function estCalendrier(l) {
    var v = (window.MIRTHLY_DATA && window.MIRTHLY_DATA.variants) || [];
    for (var i = 0; i < v.length; i++) if (String(v[i].id) === String(l.variant_id)) return true;
    return CAL_RE.test(l.variant_title || "");
  }

  /* B1 — Le client choisit sa formule avec les cartes de pack, jamais
     avec + / - : 2 x « 1 calendar » coutait 79,98 $ contre 59,92 $ pour le
     pack. Le selecteur de quantite est remplace par un lien « Remove ».
     Pendant une offre BUY 1 GET 1, le pas-a-pas par paire reste en place. */
  function sansQuantite(r, l) {
    var qty = $(".qty", r);
    var rm = $(".mc-rm", r);
    if (bogoActif() || !estCalendrier(l)) {
      r.classList.remove("mc-noqty");
      if (rm) rm.parentNode.removeChild(rm);
      return;
    }
    r.classList.add("mc-noqty");
    if (!rm) {
      rm = document.createElement("button");
      rm.type = "button";
      rm.className = "mc-rm";
      rm.textContent = "Remove";
      if (qty && qty.parentNode) qty.parentNode.insertBefore(rm, qty.nextSibling);
      else if (r.children[1]) r.children[1].appendChild(rm);
    }
    rm.setAttribute("data-key", l.key);
    rm.setAttribute("aria-label", "Remove " + (l.variant_title || l.product_title) + " from cart");
    rm.onclick = function () {
      var C = (typeof CART !== "undefined" && CART) ? CART : null;
      if (C && C.busy) return;
      if (C) C.busy = true;
      rm.disabled = true;
      envoyer("/cart/change.js", { id: rm.getAttribute("data-key"), quantity: 0 })
        .then(function (cart) { if (C && cart && cart.items) C.data = cart; })
        .catch(function () {})
        .then(function () {
          if (C) C.busy = false;
          if (typeof window.refreshCart === "function") return window.refreshCart();
        })
        .then(function () { peindre(); });
    };
  }

  function rangeeProduit(r, l) {
    sansQuantite(r, l);
    var mid = r.children[1];
    if (!mid) return;
    var nom = $(".li-n", mid);
    var prix = $(".li-p", r);

    /* Pastille du lot, devant le titre. */
    var n = parUnite(l);
    var pastille = $(".mc-pack", mid);
    if (n > 1) {
      if (!pastille) {
        pastille = document.createElement("span");
        pastille.className = "mc-pack";
        mid.insertBefore(pastille, mid.firstChild);
      }
      pastille.textContent = n + "-PACK";
    } else if (pastille) {
      pastille.parentNode.removeChild(pastille);
    }

    /* Sous-titre : mirthly.js pose un .li-s avec le titre de variante brut.
       On le reutilise s il existe, on le cree sinon. */
    var sous = $(".li-s", mid);
    if (!sous) {
      sous = document.createElement("div");
      sous.className = "li-s";
      if (nom && nom.nextSibling) mid.insertBefore(sous, nom.nextSibling);
      else mid.appendChild(sous);
    }
    sous.className = "li-s mc-sub";
    sous.textContent = libelle(l);

    /* Prix paye, puis prix barre reel s il existe. */
    if (prix) {
      var barre = compareAt(l);
      var total = barre ? barre * l.quantity : 0;
      prix.textContent = money(l.final_line_price);
      if (total > l.final_line_price) {
        prix.insertAdjacentHTML("beforeend",
          '<span class="mc-was">' + money(total) + "</span>");
      }
    }
  }

  /* ----------------------------------------------------------------
     BUY 1 GET 1 FREE
     ----------------------------------------------------------------
     Shopify decoupe lui-meme la variante en deux lignes : une payee, une a
     0 $ qui porte la remise. On habille la ligne a 0 $ en  FREE  (prix reel
     barre, puis 0 $) et on garde le pas-a-pas sur la ligne payee. Si un jour
     Shopify garde une seule ligne partiellement remisee, une rangee  FREE
     est ajoutee dessous : les deux formes sont couvertes. */

  function lignesOffre(cart) {
    var b = bogo();
    if (!b) return [];
    return (cart.items || []).filter(function (l) {
      return String(l.variant_id) === b.variantId && !estCadeau(l);
    });
  }

  function remplirGratuite(d, l, unites, montant) {
    var T = (bogo() && bogo().textes) || {};
    var mid = d.children[1];
    if (!mid) return;
    var sous = $(".li-s", mid);
    if (!sous) {
      sous = document.createElement("div");
      mid.appendChild(sous);
    }
    sous.className = "li-s mc-sub";
    sous.textContent = unites + (unites === 1 ? " calendar" : " calendars") +
      " \u2014 " + (T.freeWord || "free");
    var tag = $(".mc-free-tag", mid);
    if (!tag) {
      tag = document.createElement("span");
      tag.className = "mc-free-tag";
      mid.appendChild(tag);
    }
    tag.textContent = T.free || "FREE \uD83C\uDF81";
    var prix = $(".li-p", d);
    if (prix) {
      prix.innerHTML = '<s class="mc-free-was"></s><span class="mc-free-now"></span>';
      $(".mc-free-was", prix).textContent = money(montant);
      $(".mc-free-now", prix).textContent = money(0);
    }
  }

  /* Ligne entierement offerte : on la rhabille sur place. */
  function rangeeOfferte(r, l, g) {
    r.classList.add("mc-free-row");
    var pk = $(".mc-pack", r);
    if (pk) pk.parentNode.removeChild(pk);
    remplirGratuite(r, l, g.unites, g.montant);
  }

  /* Ligne partiellement offerte : rangee FREE ajoutee dessous. */
  function rangeeGratuite(r, l, g) {
    var d = document.createElement("div");
    d.className = "li mc-free-row mc-free-synth";
    d.innerHTML = '<div class="li-img"></div><div><div class="li-n"></div></div><div class="li-p"></div>';
    var img = $(".li-img", r);
    if (img) d.firstChild.innerHTML = img.innerHTML;
    $(".li-n", d).textContent = l.product_title;
    remplirGratuite(d, l, g.unites, g.montant);
    return d;
  }

  /* Pas-a-pas par paire sur la ligne payee : + ajoute 1 paye + 1 offert,
     - retire la paire entiere. On ecrit la quantite TOTALE de la variante
     sur une seule ligne (les autres a 0) : Shopify redecoupe ensuite. */
  function pasParPaire(r, cart) {
    var ls = lignesOffre(cart);
    var n = 0, offerts = 0;
    ls.forEach(function (l) { n += l.quantity; offerts += gratuitsDe(l).unites; });
    var payes = n - offerts;

    var aff = $(".qty span", r);
    if (aff) aff.textContent = String(payes);
    var sous = $(".li-s", r);
    if (sous) sous.textContent = payes + (payes === 1 ? " calendar" : " calendars");

    var btns = $$(".qty button", r);
    if (btns.length !== 2) return;
    var cibles = [Math.max(0, n % 2 ? n - 1 : n - 2), n % 2 ? n + 1 : n + 2];
    btns[0].setAttribute("aria-label", "Remove one pair (1 paid + 1 free)");
    btns[1].setAttribute("aria-label", "Add one pair (1 paid + 1 free)");
    btns.forEach(function (btn, i) {
      /* onclick remplace celui de mirthly.js, qui changerait une seule unite. */
      btn.onclick = function () {
        if (typeof CART === "undefined" || !CART || CART.busy) return;
        CART.busy = true;
        var maj = {};
        ls.forEach(function (l, k) { maj[l.key] = k === 0 ? cibles[i] : 0; });
        envoyer("/cart/update.js", { updates: maj })
          .then(function (c) { if (c && c.items) CART.data = c; })
          .catch(function () {})
          .then(function () {
            CART.busy = false;
            if (typeof window.renderCart === "function") window.renderCart();
          });
      };
    });
  }

  /* Bandeau vert sous les calendriers : l economie REELLE (somme des
     remises BOGO de /cart.js) et le temps restant. */
  function bandeBogo(montant) {
    var b = bogo();
    if (!b || montant <= 0) return null;
    var T = b.textes || {};
    var d = document.createElement("div");
    d.className = "mc-bogo-band";
    var t = document.createElement("span");
    t.className = "mc-bogo-band__t";
    t.textContent = (T.band || "✓ BUY 1 GET 1 FREE applied — you save [amount]")
      .replace(/\[amount\]/g, money(montant));
    d.appendChild(t);
    if (b.actif()) {
      var c = document.createElement("span");
      c.className = "mc-bogo-band__c";
      c.appendChild(document.createTextNode((T.bandTimer || "⏰ Expires in") + " "));
      var h = document.createElement("b");
      h.setAttribute("data-mc-bogo-clock", "");
      h.textContent = b.horloge();
      c.appendChild(h);
      d.appendChild(c);
    }
    return d;
  }

  /* Un seul calendrier au panier pendant l offre (panier compose avant,
     ou quantite impaire) : on PROPOSE le second, offert. On ne l ajoute
     jamais tout seul — c est le client qui clique. */
  function relanceBogo(cart) {
    if (!bogoActif()) return null;
    var b = bogo();
    var n = 0;
    lignesOffre(cart).forEach(function (l) { n += l.quantity; });
    if (n % 2 === 0) return null;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "mc-bogo-nudge";
    btn.textContent = (b.textes && b.textes.nudge) || "🎁 Add your FREE 2nd calendar";
    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      btn.disabled = true;
      envoyer("/cart/add.js", { items: [{ id: Number(b.variantId), quantity: 1 }] })
        .catch(function () {})
        .then(function () { if (typeof window.refreshCart === "function") return window.refreshCart(); })
        .then(function () { peindre(); });
    });
    return btn;
  }

  /* Bande du cadeau. Elle n apparait que si Shopify a bien porte la ligne a
     zero : tant que la remise automatique n a pas fait son travail, on
     n annonce pas un cadeau que la caisse facturerait. */
  function bandeCadeau(body, ligne) {
    var vieille = $(".mc-gift", body);
    if (vieille) vieille.parentNode.removeChild(vieille);
    if (!ligne || ligne.final_line_price !== 0 || ligne.original_line_price <= 0) return null;

    var b = document.createElement("div");
    b.className = "mc-gift";
    /* La vignette detouree passe avant la photo du produit : celle-ci a un
       fond blanc qui ferait un rectangle au milieu de la bande verte. */
    var d = $("#drawer");
    var src = (d && d.getAttribute("data-mc-gift-image")) || "";
    if (!src && ligne.image) {
      src = ligne.image.replace(/(\.[a-z]+)(\?|$)/i, "_80x$1$2");
    }
    /* Le nom court vient des reglages : le titre catalogue complet passe a
       la ligne dans une bande de 340 px et coute une hauteur pour rien.
       Vide, on retombe sur le titre reel, qui ne peut pas etre faux. */
    var nom = reglage("data-mc-gift-label", "") || (ligne.product_title + " included");
    /* Offre BUY 1 GET 1 : un cadeau par paire. */
    if (ligne.quantity > 1) nom = ligne.quantity + " × " + nom;
    b.innerHTML =
      (src ? '<img src="' + src + '" width="26" height="26" alt="" loading="lazy" decoding="async">' : "") +
      "<span>" + nom + " &mdash; <b>" +
      money(ligne.original_line_price) + " value</b></span>";
    return b;
  }

  /* ----------------------------------------------------------------
     Selecteur de formule
     ----------------------------------------------------------------
     Passe de 1 a 2 calendriers sans quitter le panier. Les prix viennent
     des variantes Shopify (MIRTHLY_DATA), jamais d un texte.

     Affiche seulement quand le panier contient UNE ligne de calendrier en
     quantite 1 : avec plusieurs lignes ou une quantite de 2, un echange de
     variante changerait ce que le client a compose lui-meme.

     On AJOUTE la nouvelle formule avant de RETIRER l ancienne : le panier
     n est jamais vide de calendrier, donc la regle du cadeau offert ne le
     retire pas et ne le remet pas entre les deux appels. Si l ajout echoue,
     rien n est retire. */
  var bascule = false;

  function variantesFormule() {
    var v = (window.MIRTHLY_DATA && window.MIRTHLY_DATA.variants) || [];
    return v.filter(function (x) { return x && x.id; });
  }

  function selecteur(cart) {
    if (reglage("data-mc-switch", "true") !== "true") return null;
    /* Pendant l offre, pas de 2-pack a 59,92 $ : il serait moins
       avantageux que 2 calendriers pour 39,99 $. */
    if (bogoActif()) return null;
    var variantes = variantesFormule();
    if (variantes.length < 2) return null;
    var lignes = (cart.items || []).filter(function (l) { return !estCadeau(l) && !estOption(l); });
    if (lignes.length !== 1 || lignes[0].quantity !== 1) return null;
    var ligne = lignes[0];
    var ids = variantes.map(function (v) { return String(v.id); });
    var courant = ids.indexOf(String(ligne.variant_id));
    if (courant === -1) return null;

    /* B2 — les trois formules, toujours. */
    var choix = [];
    for (var ci = 0; ci < Math.min(3, variantes.length); ci++) choix.push(ci);
    if (courant > 2) choix.push(courant);

    var box = document.createElement("div");
    box.className = "mc-switch" + (choix.length > 2 ? " mc-switch--3" : "");
    box.setAttribute("role", "radiogroup");
    box.setAttribute("aria-label", "Choose your bundle");

    choix.forEach(function (i) {
      var v = variantes[i];
      if (!v || (v.available === false && i !== courant)) return;
      var b = document.createElement("button");
      b.type = "button";
      b.className = "mc-switch__opt";
      b.setAttribute("role", "radio");
      b.setAttribute("aria-checked", i === courant ? "true" : "false");
      b.setAttribute("data-variant", v.id);

      var eco = v.compare > v.price ? v.compare - v.price : 0;
      var html = "";
      var flagTxt = i === 1 ? reglage("data-mc-switch-flag", "Most popular")
                  : i === 2 ? reglage("data-mc-switch-flag3", "") : "";
      if (flagTxt) html += '<span class="mc-switch__flag"></span>';
      /* Economie calculee sur les vrais prix Shopify : prix barre de la
         variante (N x prix unitaire) moins son prix, arrondie vers le bas. */
      html += '<span class="mc-switch__t"></span>' +
              '<span class="mc-switch__p">' + money(v.price) + "</span>" +
              (eco >= 100 ? '<span class="mc-switch__s">Save ' + moneyRond(eco) + "</span>" : "");
      b.innerHTML = html;
      /* Les textes des reglages passent par textContent. */
      $(".mc-switch__t", b).textContent = v.title || "";
      var f = $(".mc-switch__flag", b);
      if (f) f.textContent = (i === 1 ? "\u2B50 " : "") + flagTxt;

      b.addEventListener("click", function () {
        if (i === courant || bascule) return;
        basculer(ligne, v.id, box);
      });
      box.appendChild(b);
    });
    /* Version Noel : passer au pack de 2 en un clic quand le panier
       contient 1 calendrier. Montants calcules sur les vrais prix. */
    if (reglage("data-mc-upsell", "false") === "true" && courant === 0 && variantes[1] && variantes[1].available !== false) {
      var v1 = variantes[0], v2 = variantes[1];
      var up = document.createElement("button");
      up.type = "button";
      up.className = "mc-upsell";
      up.textContent = "Add a 2nd for " + money(v2.price - v1.price) + " more \u2014 " + money(Math.floor(v2.price / 2)) + " each";
      up.addEventListener("click", function () { if (!bascule) basculer(ligne, v2.id, box); });
      box.insertBefore(up, box.firstChild);
    }
    return box.children.length > 1 ? box : null;
  }

  function envoyer(url, corpsJson) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(corpsJson)
    }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }

  /* La cle d une ligne n est pas stable : quand la remise du cadeau se
     rattache au nouveau lot, Shopify regenere la cle de l ancienne ligne.
     On relit donc le panier apres l ajout et on retire l ancienne formule
     par sa VARIANTE, avec la cle du moment. */
  function basculer(ligne, idCible, box) {
    bascule = true;
    box.setAttribute("aria-busy", "true");
    var ancienne = String(ligne.variant_id);
    envoyer("/cart/add.js", { items: [{ id: Number(idCible), quantity: 1 }] })
      .then(function () { return jsonGet("/cart.js"); })
      .then(function (cart) {
        var chaine = Promise.resolve();
        (cart.items || []).forEach(function (l) {
          if (String(l.variant_id) !== ancienne || estCadeau(l) || estOption(l)) return;
          chaine = chaine.then(function () {
            return envoyer("/cart/change.js", { id: l.key, quantity: 0 });
          });
        });
        return chaine;
      })
      .catch(function () {})
      .then(function () {
        bascule = false;
        if (typeof window.refreshCart === "function") return window.refreshCart();
      })
      .then(function () { peindre(); });
  }

  /* Ordre du corps : ce qu on achete, ce qu on recoit en plus, puis ce
     qu on peut encore ajouter. */
  function corps(body, cart) {
    /* Nos ajouts d un rendu precedent : la peinture passe deux fois (tout
       de suite, puis apres relecture de /cart.js). */
    $$(".mc-free-synth, .mc-bogo-band, .mc-bogo-nudge", body).forEach(function (e) {
      e.parentNode.removeChild(e);
    });

    var rangees = $$(".li", body);
    var ligneCadeau = null;
    var offerts = 0;
    var b = bogo();
    var payee = null;          /* derniere rangee payee de l offre */
    var libres = [];           /* rangees entierement offertes */

    rangees.forEach(function (r) {
      var l = ligneDe(r, cart);
      if (!l) return;
      if (estCadeau(l)) { r.classList.add("gift"); ligneCadeau = l; return; }
      if (estOption(l)) { r.classList.add("mc-optline"); return; }
      var g = gratuitsDe(l);
      offerts += g.montant;
      if (g.unites > 0 && g.unites === l.quantity) {
        rangeeOfferte(r, l, g);
        libres.push(r);
        return;
      }
      r.classList.remove("mc-free-row");
      rangeeProduit(r, l);
      if (b && String(l.variant_id) === b.variantId) {
        payee = r;
        if (b.actif()) pasParPaire(r, cart);
        else if (g.unites > 0) {
          var sous = $(".li-s", r);
          if (sous) sous.textContent = (l.quantity - g.unites) + " calendar" + (l.quantity - g.unites === 1 ? "" : "s");
        }
      }
      if (g.unites > 0) r.parentNode.insertBefore(rangeeGratuite(r, l, g), r.nextSibling);
    });

    /* Le calendrier offert juste sous le calendrier paye, quel que soit
       l ordre des lignes renvoye par Shopify. */
    if (payee) {
      var ancre = payee;
      while (ancre.nextSibling && ancre.nextSibling.classList &&
             ancre.nextSibling.classList.contains("mc-free-synth")) ancre = ancre.nextSibling;
      libres.forEach(function (r) {
        ancre.parentNode.insertBefore(r, ancre.nextSibling);
        ancre = r;
      });
    }

    var apres = null;
    $$(".li", body).forEach(function (r) {
      if (!r.classList.contains("gift") && !r.classList.contains("mc-optline")) apres = r;
    });

    function poser(el) {
      if (!el) return;
      if (apres && apres.nextSibling) body.insertBefore(el, apres.nextSibling);
      else if (apres) body.appendChild(el);
      else body.insertBefore(el, body.firstChild);
      apres = el;
    }

    var vieuxSel = $(".mc-switch", body);
    if (vieuxSel) vieuxSel.parentNode.removeChild(vieuxSel);
    poser(selecteur(cart));
    poser(bandeBogo(offerts));
    poser(relanceBogo(cart));
    /* B3 — la grande bande verte « BONUS HOT SHOTS INCLUDED » est retiree :
       le cadeau n est rappele qu une fois, par la ligne compacte du
       recapitulatif, avec sa vignette. */
    var vieilleBande = $(".mc-gift", body);
    if (vieilleBande) vieilleBande.parentNode.removeChild(vieilleBande);
  }

  /* ----------------------------------------------------------------
     Recapitulatif
     ---------------------------------------------------------------- */
  function ligneSomme(etiquette, valeur, vert) {
    var d = document.createElement("div");
    d.className = "dw-sum";
    d.innerHTML = "<span>" + etiquette + "</span><span" +
      (vert ? ' class="save"' : "") + ">" + valeur + "</span>";
    return d;
  }

  /* Vignette du cadeau : la version detouree des reglages, sinon la photo
     de la ligne Shopify. */
  function vignetteCadeau(cart) {
    var d = $("#drawer");
    var src = (d && d.getAttribute("data-mc-gift-image")) || "";
    if (src) return src;
    var l = (cart.items || []).filter(estCadeau)[0];
    return l && l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, "_80x$1$2") : "";
  }

  /* B4 — la note mene aux avis : on ferme le tiroir puis on defile. */
  function versAvis(e) {
    var cible = document.getElementById("reviews");
    if (!cible) return;
    e.preventDefault();
    /* closeCart rend le focus au bouton qui avait ouvert le tiroir, ce qui
       ramene la page vers lui : on place ensuite le focus sur les avis
       (sans defiler), puis on defile. Si le defilement doux n a pas abouti
       (navigateur qui l ignore), on saute directement. */
    if (typeof window.closeCart === "function") window.closeCart();
    setTimeout(function () {
      if (!cible.hasAttribute("tabindex")) cible.setAttribute("tabindex", "-1");
      try { cible.focus({ preventScroll: true }); } catch (err) {}
      cible.scrollIntoView({ behavior: "smooth", block: "start" });
      setTimeout(function () {
        var haut = cible.getBoundingClientRect().top;
        if (Math.abs(haut) > 60) {
          window.scrollTo({ top: window.pageYOffset + haut - 8, behavior: "instant" });
        }
      }, 800);
    }, 120);
  }

  function resume(cart, c) {
    var foot = $("#dwFoot");
    if (!foot) return;
    var cta = $("#dwCheckout", foot);
    if (!cta) return;

    /* On retire nos anciens ajouts et les lignes de mirthly.js, mais on
       garde le bouton : il porte le gestionnaire de redirection. */
    $$(".dw-sum, .mc-rule, .mc-trust, .mc-express, .mc-eta, .mc-pay", foot).forEach(function (e) {
      e.parentNode.removeChild(e);
    });

    var avant = document.createDocumentFragment();

    /* Une seule ligne d economie a la place du detail. Le montant
       additionne la remise du lot et toute autre remise Shopify ; le
       cadeau n est cite que si Shopify l a bien porte a 0 $. */
    var eco = c.lot + Math.max(0, c.reste);
    var gain = null;
    if (c.bogo > 0) {
      /* Le bandeau vert BUY 1 GET 1, dans le corps, dit deja l economie :
         la repeter ici ferait deux montants differents a l ecran. */
      gain = null;
    } else if (eco >= 100 && c.cadeau > 0) {
      gain = reglage("data-mc-save-both", "You save [amount] + free Hot Shots gift");
    } else if (eco >= 100) {
      gain = reglage("data-mc-save-amount", "You save [amount]");
    } else if (c.cadeau > 0) {
      gain = reglage("data-mc-save-gift", "Free Hot Shots gift included");
    }
    if (gain) {
      var g = document.createElement("div");
      g.className = "dw-sum mc-save";
      if (c.cadeau > 0) {
        var vig = vignetteCadeau(cart);
        if (vig) {
          var gi = document.createElement("img");
          gi.className = "mc-save__img";
          gi.src = vig; gi.alt = ""; gi.width = 24; gi.height = 24;
          g.appendChild(gi);
        }
      }
      var gs = document.createElement("span");
      gs.textContent = "\u2713 " + gain.replace(/\[amount\]/g, moneyRond(eco));
      g.appendChild(gs);
      avant.appendChild(g);
    }

    var portFranco = reglage("data-mc-free-shipping", "true") === "true";
    avant.appendChild(ligneSomme("Shipping",
      portFranco ? "<b class=\"save\">Free</b>" : "Calculated at checkout"));

    var rule = document.createElement("hr");
    rule.className = "mc-rule";
    avant.appendChild(rule);

    var tot = document.createElement("div");
    tot.className = "dw-sum tot";
    tot.innerHTML = "<span>TOTAL</span><span>" + money(c.total) + "</span>";
    avant.appendChild(tot);

    foot.insertBefore(avant, cta);

    cta.innerHTML = "Secure Checkout &mdash; " + money(c.total) +
      ' <span aria-hidden="true">&rarr;</span>';

    /* Date de livraison estimee, juste sous le bouton. */
    var e = livraison();
    if (e) {
      var pe = document.createElement("p");
      pe.className = "mc-eta";
      pe.textContent = "\uD83D\uDCE6 " + e;
      foot.appendChild(pe);
    }

    /* Moyens de paiement : les logos viennent du gabarit Liquid, qui ne
       rend que les moyens ACTIVES dans Shopify. */
    var pay = document.createElement("div");
    pay.className = "mc-pay";
    var modele = document.getElementById("mcPayIcons");
    if (modele && modele.content) {
      var icones = document.createElement("span");
      icones.className = "mc-pay__icons";
      icones.appendChild(modele.content.cloneNode(true));
      if (icones.querySelector("svg, img")) pay.appendChild(icones);
    }
    var sec = reglage("data-mc-secure", "\uD83D\uDD12 100% secure payment");
    if (sec) {
      var ss = document.createElement("span");
      ss.className = "mc-pay__t";
      ss.textContent = sec;
      pay.appendChild(ss);
    }
    if (pay.children.length) foot.appendChild(pay);

    /* Note des clients, puis la reassurance existante. */
    var trust = document.createElement("p");
    trust.className = "mc-trust";
    var note = reglage("data-mc-rating", "");
    if (note) {
      var sn = document.createElement("a");
      sn.className = "mc-rating";
      sn.href = "#reviews";
      sn.textContent = note;
      sn.addEventListener("click", versAvis);
      trust.appendChild(sn);
    }
    var t2 = document.createElement("span");
    t2.innerHTML = reglage("data-mc-trust",
      "<b>&#10003;</b> Free shipping on all orders <b>&#10003;</b> 30-day returns");
    trust.appendChild(t2);
    foot.appendChild(trust);

    var wallets = $(".dw-wallets");
    if (wallets && wallets.children.length) {
      wallets.hidden = false;
      var lab = document.createElement("p");
      lab.className = "mc-express";
      lab.textContent = "Express checkout";
      foot.appendChild(lab);
    }
  }

  /* Fenetre de livraison : aujourd hui + N jours OUVRES (samedi et
     dimanche exclus), dans le fuseau du client. Meme calcul que la fiche
     produit et que la page du pyjama. La mention  Arrives before  n apparait
     que si la fin de la fenetre tombe AVANT la date limite de l annee en
     cours : apres, elle serait fausse, on la tait. */
  function livraison() {
    var min = parseInt(reglage("data-mc-eta-min", "7"), 10);
    var max = parseInt(reglage("data-mc-eta-max", "14"), 10);
    if (isNaN(min) || isNaN(max) || min < 0 || max < min) return null;
    var auj = new Date();
    var ouvres = function (n) {
      var x = new Date(auj.getFullYear(), auj.getMonth(), auj.getDate());
      while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
      return x;
    };
    var d1 = ouvres(min);
    var d2 = ouvres(max);
    var fmt = function (d) {
      try { return d.toLocaleDateString("en-US", { month: "short", day: "numeric" }); }
      catch (err) { return (d.getMonth() + 1) + "/" + d.getDate(); }
    };
    var txt = reglage("data-mc-eta-label", "Estimated delivery") + ": " + fmt(d1) + " \u2013 " + fmt(d2);
    /* Version Noel : meme fenetre (jours feries exclus) et date limite de
       Noel que la fiche, a la place de « Arrives before Dec 1 ». */
    if (window.MirthlyXmas) {
      return reglage("data-mc-eta-label", "Estimated delivery") + ": " + window.MirthlyXmas.window() +
        " \u00B7 " + window.MirthlyXmas.short();
    }
    var lim = /^(\d{1,2})-(\d{1,2})$/.exec(reglage("data-mc-eta-before", ""));
    if (lim) {
      var dl = new Date(auj.getFullYear(), Number(lim[1]) - 1, Number(lim[2]));
      if (d2 < dl) txt += " \u00B7 Arrives before " + fmt(dl);
    }
    return txt;
  }

  function annoncer(texte) {
    var z = $("#mcLive");
    if (!z) {
      z = document.createElement("p");
      z.id = "mcLive";
      z.setAttribute("aria-live", "polite");
      z.setAttribute("role", "status");
      z.style.cssText = "position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)";
      document.body.appendChild(z);
    }
    z.textContent = texte;
  }

  /* Peinture synchrone, a partir d un panier deja connu. Aucun appel
     reseau : elle peut s executer dans la meme tache que le rendu de
     mirthly.js, avant que le navigateur n affiche quoi que ce soit. */
  function peindreAvec(cart) {
    var body = $("#dwBody");
    if (!body || !cart || !cart.items) return;
    if (!cart.items.length) {
      enTete(0);
      var w = $(".dw-wallets");
      if (w) w.hidden = true;
      return;
    }
    var c = comptes(cart);
    enTete(c.articles);
    corps(body, cart);
    resume(cart, c);
  }

  function peindre() {
    var body = $("#dwBody");
    if (!body) return;

    jsonGet("/cart.js").then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) {
        enTete(0);
        var w = $(".dw-wallets");
        if (w) w.hidden = true;
        return;
      }
      /* Les prix barres avant tout le reste : sans eux le recapitulatif
         afficherait un sous-total avant remises egal au total, et la ligne
         du lot disparaitrait alors qu il y a bien une economie. */
      var handles = cart.items
        .filter(function (l) { return !estCadeau(l) && !estOption(l); })
        .map(function (l) { return l.handle; });

      return Promise.all(handles.map(fiche)).then(function () {
        var c = comptes(cart);
        enTete(c.articles);
        corps(body, cart);
        resume(cart, c);
        annoncer("Cart updated. " + c.calendriers +
          (c.calendriers === 1 ? " calendar" : " calendars") +
          ", total " + money(c.total) + ".");
      });
    }).catch(function () { /* le tiroir d origine reste utilisable */ });
  }

  /* ----------------------------------------------------------------
     Accessibilite : entree du focus et piege
     ---------------------------------------------------------------- */

  var SELECTEUR_FOCUS =
    'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),' +
    'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function focusables(d) {
    return $$(SELECTEUR_FOCUS, d).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function piege(d) {
    d.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var f = focusables(d);
      if (!f.length) return;
      var premier = f[0], dernierEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) {
        e.preventDefault(); dernierEl.focus();
      } else if (!e.shiftKey && document.activeElement === dernierEl) {
        e.preventDefault(); premier.focus();
      }
    });
  }

  function init() {
    var d = $("#drawer");
    if (!d || d.dataset.mcReady === "1") return;
    d.dataset.mcReady = "1";

    piege(d);

    /* mirthly.js gere deja Echap, le verrou de defilement et le retour du
       focus a la fermeture. Il ne place pas le focus DANS le tiroir a
       l ouverture : au clavier et au lecteur d ecran, on restait sur la page
       derriere. On surveille aria-hidden plutot que d envelopper openCart,
       ce qui couvre aussi les ouvertures declenchees autrement. */
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName !== "aria-hidden") return;
        if (d.getAttribute("aria-hidden") === "false") {
          /* La feuille est encore en visibility:hidden pendant sa
             transition d ouverture, et .focus() n a alors aucun effet.
             On reessaie quelques fois plutot que de parier sur un delai. */
          var c = $("#dwClose", d);
          /* Un vrai rendu, pas seulement une decoration : le panier a pu
             changer ailleurs pendant que le tiroir etait ferme. */
          if (typeof window.refreshCart === "function") window.refreshCart();
          if (c) {
            var essais = 0;
            var poser = function () {
              if (document.activeElement === c || essais++ > 12) return;
              c.focus();
              setTimeout(poser, 60);
            };
            setTimeout(poser, 60);
          }
          peindre();
        }
      });
    }).observe(d, { attributes: true, attributeFilter: ["aria-hidden"] });

    /* Chaque rendu du panier efface nos ajouts : on repeint derriere.

       Avant, la repeinture attendait un aller-retour reseau (/cart.js) :
       pendant 200 a 300 ms le client voyait le panier BRUT de mirthly.js
       (ligne cadeau a 0 $, Subtotal / Discounts, bouton  Checkout ). On
       repeint desormais tout de suite avec le panier que mirthly.js vient
       lui-meme de recevoir (CART.data), dans la meme tache : le navigateur
       n affiche jamais la version brute. La relecture reseau reste
       derriere, pour les cas ou CART.data serait incomplet. */
    if (typeof window.renderCart === "function" && !window.renderCart.__mcDrawer) {
      var origine = window.renderCart;
      var enveloppe = function () {
        var out = origine.apply(this, arguments);
        try {
          if (typeof CART !== "undefined" && CART && CART.data) peindreAvec(CART.data);
        } catch (err) {}
        setTimeout(peindre, 0);
        return out;
      };
      enveloppe.__mcDrawer = true;
      window.renderCart = enveloppe;
    }

    /* La pastille de l en-tete (mirthly.js) affiche item_count : un lot
       de 2 + le cadeau offert = 2. On la recale sur le nombre de lots.
       updatePip est une fonction globale de mirthly.js, appelee par son
       nom : l envelopper suffit. CART est sa variable globale du panier. */
    if (typeof window.updatePip === "function" && !window.updatePip.__mcCompte) {
      var pipOrigine = window.updatePip;
      var pipEnveloppe = function () {
        var out = pipOrigine.apply(this, arguments);
        try {
          var data = (typeof CART !== "undefined" && CART) ? CART.data : null;
          if (data) {
            var n = articles(data.items);
            var pip = document.getElementById("cartPip");
            if (pip) pip.textContent = String(n);
            var cnt = document.getElementById("dwCount");
            if (cnt) cnt.textContent = n ? "(" + n + ")" : "";
          }
        } catch (err) {}
        return out;
      };
      pipEnveloppe.__mcCompte = true;
      window.updatePip = pipEnveloppe;
    }

    if (d.getAttribute("aria-hidden") === "false") peindre();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
